import { isCalendarDateKey } from '@/app/utils/formatDate';

const pad = (value: number): string => String(value).padStart(2, '0');

export const localDateKey = (now: Date): string =>
    `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;

export function isOverdue(dueDate: string | null, today: string): boolean {
    if (dueDate === null) return false;
    const key = dueDate.slice(0, 10);
    return isCalendarDateKey(key) && key < today;
}
